import { graphql } from '../../gql';

export const LogoutDocument = graphql(/* GraphQL */ `
  mutation Logout {
    logout {
      success
      logoutUrl
    }
  }
`);
